import { type, textColor, surface } from '@datahub/design-system'

export interface PortalNavItem {
  key: string
  label: string
}

interface PortalSidebarProps {
  /** Eyebrow above the items, e.g. "Datahub reporting". */
  section: string
  items: PortalNavItem[]
  active: string
  onSelect: (key: string) => void
}

/**
 * 256px sidebar from the Figma "Portfolio Reporting" frame (node 4352:18988):
 * a 10px eyebrow, then 14px items on 32px rows. The active row is filled with the
 * page surface and its label turns white; the rest sit in the muted grey.
 */
export function PortalSidebar({ section, items, active, onSelect }: PortalSidebarProps) {
  return (
    <nav
      aria-label="Reporting sections"
      className="flex-shrink-0 flex flex-col"
      style={{
        width: 256,
        backgroundColor: surface.panel,
        borderRight: `0.5px solid ${surface.border}`,
      }}
    >
      <div
        className="flex items-center"
        style={{ height: 32, padding: '0 20px', backgroundColor: surface.page }}
      >
        <span className="font-jakarta" style={{ ...type.eyebrow, color: textColor.muted }}>
          {section}
        </span>
      </div>

      {items.map((item) => {
        const selected = item.key === active
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onSelect(item.key)}
            aria-current={selected ? 'page' : undefined}
            className="flex items-center text-left w-full"
            style={{
              height: 44,
              padding: '0 20px',
              border: 'none',
              cursor: 'pointer',
              backgroundColor: selected ? surface.page : 'transparent',
              borderBottom: `0.5px solid ${surface.border}`,
            }}
          >
            <span
              className="font-jakarta"
              style={{
                ...type.tab,
                fontWeight: 500,
                color: selected ? textColor.primary : textColor.muted,
              }}
            >
              {item.label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}
